module.exports = __webpack_public_path__ + "img/centCorte.68c84fcf.jpg";